import { render, staticRenderFns } from "./result-counter.vue?vue&type=template&id=e9fa2268&scoped=true&"
import script from "./result-counter.vue?vue&type=script&lang=js&"
export * from "./result-counter.vue?vue&type=script&lang=js&"
import style0 from "./result-counter.vue?vue&type=style&index=0&id=e9fa2268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fa2268",
  null
  
)

export default component.exports